import { useMediaQueries } from '@react-hook/media-query';
import { QUERIES } from '@src/consts/common';
import { TQueries } from '@src/models/common';
import { useEffect, useState } from 'react';
import { getBreakpoint } from './utils';

/**
 * Хук возвращает breakpoint соответствующий текущей ширине экрана или
 *
 * @deprecated Не используй хук для работы с компонентами в проектах с ssr `NextJS` из-за возможной проблемы
 * когда при первоначальном рендере на стороне сервера мы получали некорректное значение возвращаемое из хука и в следствии некоректное отображение компонент.
 * Замена на использовании контекста в данном случае решило проблему
 * @link https://nextjs.org/docs/messages/react-hydration-error
 * @example
 * const {breakpoint, isMobile} = useContext(BreakpointContext)
 */
export const useBreakpoints = () => {
  const { matches } = useMediaQueries<TQueries>(QUERIES);
  const [breakpoint, setBreakpoint] = useState<keyof TQueries | undefined>(getBreakpoint(matches));

  useEffect(() => {
    setBreakpoint(getBreakpoint(matches));
  }, [matches]);

  return {
    isMobile: breakpoint === 'MOBILE',
    breakpoint,
  };
};
